export default "/static-assets/_next/static/locales/de/common.33cee45085466d0f2547d4a9dd39fbde.json";